module.exports = __webpack_public_path__ + "img/caa03b5.png";